<template>
	<div>
		<div class="row">
			<div class="col-md-12 p-0">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>CUSTOMER REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-21px;">   
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<CustomerReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import CustomerReportTab from '@/views/pages/CustomerReportTab.vue'

export default
{
	extends: Customer,
	components: { 
		CustomerReportTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabList:[
				{label:'Sales B2B', name: 'sales_b2b', index: '0' },
				{label:'Piutang', name: 'piutang', index: '1' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>